import { render, staticRenderFns } from "./truck_info.vue?vue&type=template&id=15708888&scoped=true&"
import script from "./truck_info.vue?vue&type=script&lang=js&"
export * from "./truck_info.vue?vue&type=script&lang=js&"
import style0 from "./truck_info.vue?vue&type=style&index=0&id=15708888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15708888",
  null
  
)

export default component.exports